export const HEALTH_QUESTIONS = [
    {
        id: 1,
        emoji: '🍽️',
        question: 'Do you feel hungry naturally at meals?',
        hindiQuestion: 'क्या आपको भोजन के समय भूख लगती है?'
    },
    {
        id: 2,
        emoji: '🚽',
        question: 'Are your bowels regular daily?',
        hindiQuestion: 'क्या आपकी मल त्याग की आदत नियमित है?'
    },
    {
        id: 3,
        emoji: '⚖️',
        question: 'Can you maintain an optimum weight?',
        hindiQuestion: 'क्या आप अपना संतुलित वजन बनाए रखते हैं?'
    },
    {
        id: 4,
        emoji: '⚡',
        question: 'Do you feel energetic throughout the day?',
        hindiQuestion: 'क्या आप पूरे दिन ऊर्जावान महसूस करते हैं?'
    },
    {
        id: 5,
        emoji: '✨',
        question: 'Does your skin look fresh and glowing?',
        hindiQuestion: 'क्या आपकी त्वचा ताज़गी और चमक से भरी है?'
    },
    {
        id: 6,
        emoji: '😴',
        question: 'Do you get deep sleep at night?',
        hindiQuestion: 'क्या आपको रात में गहरी नींद आती है?'
    },
    {
        id: 7,
        emoji: '🚶',
        question: 'Can you move freely without pain?',
        hindiQuestion: 'क्या आप बिना दर्द के सहज चल-फिर सकते हैं?'
    },
    {
        id: 8,
        emoji: '🌸',
        question: 'Do you carry positive thoughts?',
        hindiQuestion: 'क्या आपके विचार हमेशा सकारात्मक रहते हैं?'
    },
    {
        id: 9,
        emoji: '😊',
        question: 'Do you experience a natural sense of joy?',
        hindiQuestion: 'क्या आप स्वाभाविक आनंद का अनुभव करते हैं?'
    },
    {
        id: 10,
        emoji: '🤝',
        question: 'Do you feel connected with family & friends?',
        hindiQuestion: 'क्या आप परिवार और मित्रों के साथ जुड़ाव महसूस करते हैं?'
    }
];